import DialogContext, { DialogContextContent } from '../context/DialogContext';
import { useContext } from 'react';

const useDialog = (): DialogContextContent => useContext(DialogContext);

export default useDialog;
